// theme.ts
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  fonts: {
    heading: `"Noto Serif JP", "Hiragino Mincho ProN", "Hiragino Mincho Pro", "游明朝", "Yu Mincho", serif`,
    body: `"Noto Serif JP", "Hiragino Mincho ProN", "Hiragino Mincho Pro", "游明朝", "Yu Mincho", serif`,
    menu: `"noto-sans-cjk-jp", "Noto Sans CJK JP", "Noto Sans JP", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", Meiryo, sans-serif`,
    serif: `"Noto Serif JP", "Hiragino Mincho ProN", "Hiragino Mincho Pro", "游明朝", "Yu Mincho", serif`,
  },
  colors: {
    brand: {
      50: "#F1F6FA",
      100: "#D5E5EF",
      200: "#B8D3E3",
      300: "#9CC0D6",
      400: "#88AEC5",
      500: "#6D97B2",
      600: "#4F738A",
      700: "#365465",
      800: "#243A45",
      900: "#142329",
    },
    accent: {
      500: "#98BED8",
    },
    ink: {
      900: "#111111",
    },
  },
  space: {
    "page-x": "24px",
    "page-x-md": "24px",
    "page-x-lg": "32px",
    "section-y": "64px",
    "section-y-lg": "80px",
  },
  sizes: {
    "content-sm": "95vw",
    "content-md": "1120px",
    "content-lg": "1200px",
    "content-xl": "1280px",
  },
  semanticTokens: {
    colors: {
      "bg.page": { default: "white" },
      "text.body": { default: "gray.900" },
      "text.muted": { default: "gray.600" },
      "line.section": { default: "blue.200" },
      "brand.accent": { default: "brand.400" },
    },
  },
  styles: {
    global: {
      body: {
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        fontFeatureSettings: '"palt"', // クォーテーションを追加して適切に指定
        textRendering: "optimizeLegibility", // 可読性の最適化
        bg: "bg.page",
        color: "text.body",
      },
    },
  },
});

export default theme;
